import React from 'react';

const StatBox = ({ title, value }) => {
  return (
    <div style={styles.statBox}>
      <h3 style={styles.statTitle}>{title}</h3>
      <p style={styles.statValue}>{value}</p>
    </div>
  );
};

// Styles
const styles = {
  statBox: {
    backgroundColor: '#ffffff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    textAlign: 'left',
  },
  statTitle: {
    fontSize: '20px',
    color: '#727273',
    marginBottom: '5px',
  },
  statValue: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#007bff',
    marginTop: '0px',
  },
};

export default StatBox;
